import { uniqueNamesGenerator, adjectives, colors, animals, names } from 'unique-names-generator';

// Constants
export const MAX_PASSKEY_LENGTH = 128;
const MAX_GENERATION_ATTEMPTS = 10;

/**
 * Generates a random passkey with length validation
 * Uses recursive approach with attempt limit to ensure passkey length ≤ 128 characters
 * If unable to generate within limits after max attempts, truncates the result
 */
export const generateRandomPasskey = (attempt: number = 0): string => {
  const dicts = [colors, adjectives, animals, names].sort(() => Math.random() - 0.5);
  const randomPasskey = uniqueNamesGenerator({
    dictionaries: dicts,
    separator: '',
    length: 4,
    style: 'capital',
  });

  // Ensure passkey doesn't exceed maximum length
  if (randomPasskey.length > MAX_PASSKEY_LENGTH) {
    // Prevent infinite recursion by limiting attempts
    if (attempt < MAX_GENERATION_ATTEMPTS) {
      return generateRandomPasskey(attempt + 1); // Recursively try again
    } else {
      // Fallback: truncate to max length if we've exceeded max attempts
      return randomPasskey.substring(0, MAX_PASSKEY_LENGTH);
    }
  } else {
    return randomPasskey;
  }
};
